import React from "react";

const Termscondition = () => {
    return (
        <>
            <div className="breadcrumb-bar">
                <div className="container">
                    <div className="row align-items-center text-center">
                        <div className="col-md-12 col-12">
                            <h2 className="breadcrumb-title">Terms & Conditions</h2>
                            <nav aria-label="breadcrumb" className="page-breadcrumb">
                                <ol className="breadcrumb">

                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            <section className="booking-section">
                <div className="container">

                    <div className="tab-content" id="pills-tabContent">
                        <div className="tab-pane fade show active" id="pills-booking" role="tabpanel" aria-labelledby="pills-booking-tab">
                          
                                <div className="booking-title">
                                    <h3>Terms & Conditions</h3>
                                </div>

                              <div>
                              Triloki Cabs Transparency :<br></br>
1.	EXCLUDES: TOLL TAX, STATE TAX, NIGHT CHARGES & DRIVER ALLOWANCE<br></br>
2.	EXCLUDES: PARKING (IF ANY), AIRPORT CHARGES (IF ANY)<br></br><br></br>
Note :<br></br>
1.	Additional pickup/drop off charges @ Rs. 200 per additional pickup/drop-off point in radius of 5 kms. (Not allowed beyond 5kms. If allowed then additional charges may be applicable.)
<br></br>2.	Waiting charges @ Rs. 220/hr after 30 mins. Billed on Hourly Basis.
<br></br>3.	AC would be switched off in hilly areas.
<br></br>4.	Balance amount needs to be paid at the beginning of the journey.
<br></br>5.	Online Distance Charges are approximate. Extra Kilometre charges applicable.
<br></br>6.	Conveyance fee will not be counted in the booking amount advance payment.
<br></br>7.	Time & Distance Calculated from grage to grage Local Booking & Outstation Booking will not be Combine.
<br></br>8.	Cancellation:-If you cancel the booking less than 24 hrs before the pickup time, 15% of the fare amount shall be applicable as cancellation charges. If you cancel your booking less than 4 hrs before the pickup time, No refund shall be applicable.
<br></br>9.	You will receive the chauffeur details in your e-mail,& contact no at least 03 hours prior to the pik up time
<br></br>10.	Check Kilometers before you travel That is your Responsibility.
<br></br>11.	In case, if you book cab is tatkal, we will take 2 to 3 hours to confirm it. If the vehicle is available then the booking will be confirmed otherwise your booking will be cancelled.In case your booking is made one hour or two before No Refund.
<br></br>12.	Rates may increase due to high demand.
<br></br>13.	In case of vehicle accident/break-down the company will provide an alternate vehicle or will refund the advance deposit if booking stands cancelled. The customer will have to wait as much time as the company will take to find another vehicle.


                              </div>
                           

                        </div>

                    </div>
                </div>
            </section>


        </>
    )
}

export default Termscondition;